import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { Main } from './pages/shared/maincomponent'
import { initClarity } from './telemetry/clarity';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
//import { initializeIcons } from '@fluentui/font-icons-mdl2';

initClarity(process.env.REACT_APP_CLARITY_PROJECT_ID);

const rootElement = document.getElementById('root');
if (rootElement){
    ReactDOM.render(
        <React.StrictMode>
            <Main />
        </React.StrictMode>,
        rootElement
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
